import { Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import * as React from "react";
import { FileGrid } from "../../../../Components/FileGrid";
import CustomLinearProgress from "../../../../Components/Progress/LinearProgress";
import { useAppDataProvider } from "../../../../dataprovider";
import { UploadFile } from "../../../../Components/UploadFile";
import { Separator } from "../../../../Components/Separator";
import { WaitingResponseType } from "../../../../Enums/WaitingResponseType";
import { useAuth } from "@airborne/react-admin";

const PbhWaitingResponseFileComponent = props => {
  const [loading, setLoading] = React.useState(false);
  const [open, setOpen] = React.useState(props.open);
  const [gridRefresh, setGridRefresh] = React.useState(false);
  const { user } = useAuth();
  const dataProvider = useAppDataProvider();
  const handleClose = () => {
    setOpen(false);
    props?.handleClose?.();
  };

  const fileExecute = () => setGridRefresh(true);
  const gridTrigged = () => {
    if (gridRefresh) {
      setGridRefresh(false);
      return true;
    }

    return false;
  };

  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth={"lg"}
        open={open}
        onClose={handleClose}
        aria-labelledby="max-width-dialog-title"
      >
        {loading ? (
          <CustomLinearProgress loading={loading} periodTime={500} />
        ) : (
          <>
            <DialogTitle id="max-width-dialog-title"></DialogTitle>
            <DialogContent>
              <FileGrid
                source="pbhwaitingresponsefilerelations"
                filter={{
                  pbhWaitingResponseId__eq: props?.record?.id,
                }}
                canRemove={false}
                showGroup={false}
                showFileType={false}
                trigged={gridTrigged()}
              />
              <Separator />
              {props?.uploadVisible && props?.record?.waitingResponseEnum !== WaitingResponseType.Cancelled && (
                <UploadFile
                  label=""
                  multiple={false}
                  onHandleFileExecute={() => fileExecute()}
                  source="pbhwaitingresponsefilerelations"
                  object={{
                    pbhWaitingResponseId: props?.record?.id,
                    isCustomer: user?.isCustomer,
                  }}
                />
              )}
            </DialogContent>
            <DialogActions></DialogActions>
          </>
        )}
      </Dialog>
    </React.Fragment>
  );
};
export default PbhWaitingResponseFileComponent;
